export const JobPostPublishSkuDescription = () => (
  <ul className="space-y-2">
    {/* <li>Get in front of JavaScript developers around the world.</li> */}
    <li>Published forever, or until you stop it.</li>
    <li>Edit, stop or resume the post at anytime.</li>
    <li>See how many people interacted with your post.</li>
  </ul>
);

export const JobPostStickySkuDescription = () => (
  <ul className="space-y-2">
    <li>
      Your job will stay at the top of the homepage for 1 month, catching every
      visitor's eye.
    </li>
  </ul>
);

export const JobPostThreeTweetsSkuDescription = () => (
  <ul className="space-y-2">
    <li>
      We'll tweet your job to our{" "}
      <a
        href="https://twitter.com/@jobsinjs"
        target={"_blank"}
        className="underline"
      >
        18k followers
      </a>
      , reaching even more potential applicants.
    </li>
  </ul>
);
